import { postWindowMessage } from '@openeducation/oe-it-services';
import { EventNames } from '@openeducation/oe-it-shared-types';
import { useCallback } from 'react';
import { DeviceEventEmitter } from 'react-native';

export function useEventEmmiter<EventType extends string, Data = unknown>(
  eventName: EventNames = EventNames.GENERAL
) {
  const emit = useCallback(
    (eventType: EventType, data?: Data) => {
      DeviceEventEmitter?.emit(eventName, { eventType, data });

      postWindowMessage({
        type: eventType,
        data,
      });
    },
    [eventName]
  );

  return {
    emit,
  };
}
